export const env = {
  baseUrl: 'https://api.beattractive.fr/',
  sentryDsn: 'https://c601aea1ba6144008e1e3885898f7755@o1300890.ingest.sentry.io/6549943',
  clientUuid: '07db4a08-0433-4bbc-b634-7f390fbe1579',
  ENV: 'compagnonByAlize',
  featureFlags: {
    areCheatCodesEnabled: false,
    isCodePushEnabled: false,
    isCodePushManual: false,
    isFavoritesEnabled: false,
    authentication: {
      enabled: true,
      appleProviderEnabled: false,
      facebookProviderEnabled: false,
      googleProviderEnabled: false,
    },
  },
  matomoUrlBase: 'https://analytics.tools.citopia.fr/',
  matomoSiteId: 166,
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
